import React, { useEffect, useState } from "react";
import InboxTable from './InboxTable'
import { OBPSService } from '../../../../../../../libraries/src/services/elements/OBPS';
import { Loader } from "@egovernments/digit-ui-react-components";
import { convertDateToEpoch } from "@egovernments/digit-ui-libraries/src/services/atoms/Utils/Date";

function CertificateDetail({setApiData, apiData}) {
    const tenantId = Digit.ULBService.getCurrentTenantId();
    const [isLoading, setIsLoading] = useState(true);

    const fetchData = async (tenantId, params) => {
        try {
            const result = await OBPSService.selfApprovalReportData(tenantId, params);
            setApiData(result);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setIsLoading(false); 
        }
    };

    // const handleFormSubmit = async (formData) => {
    //     let { applicationType, district, applicationNo, fromDate, toDate } = formData;
    //     if (fromDate && toDate) { 
    //         const fromDateString = `${fromDate.$y}-${String(fromDate.$M + 1).padStart(2, '0')}-${String(fromDate.$D).padStart(2, '0')}`;
    //         const toDateString = `${toDate.$y}-${String(toDate.$M + 1).padStart(2, '0')}-${String(toDate.$D).padStart(2, '0')}`;
    //         // Use the convertDateToEpoch function
    //         fromDate = convertDateToEpoch(fromDateString);
    //         toDate = convertDateToEpoch(toDateString);
        
    //     }
    //     try {
    //         await fetchData(tenantId, { applicationType, district, applicationNo, fromDate, toDate });
    //     } catch (error) {
    //         console.error('Error fetching data:', error);
    //     }
    // };

    useEffect(() => {
        const fetchDataOnMount = async () => {
            await fetchData(tenantId, {applicationType: 'FORM_12', plotArea: 500, typeofArea: 'Residential'});
        };
        fetchDataOnMount();
    }, [tenantId]); // Call fetchData when tenantId changes

    return (
        <div>
            {/* <FilterForm onSubmit={handleFormSubmit}/> */}
            {isLoading && 
            <div>
                <Loader />
            </div>}
            {!isLoading && apiData && <InboxTable apiData={apiData} />}
        </div>
    )
}

export default CertificateDetail;
